import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function isImageApiEnabled(): boolean {
    return (
        isConsumer() &&
        isFeatureEnabled('rp-imageApiConsumer') &&
        !getUserConfiguration().SessionSettings.IsShadowMailbox
    );
}
